<template>
  <swiper :class="$style.box" :options="swiperOption">
    <swiper-slide
      v-for="item in hmGameList"
      :key="item.id"
      :class="$style['game-list']"
      @click.native="handleLinkTo(item.url)"
    >
      <img :src="item.images" alt="游戏icon" />
      <div>{{ item.name }}</div>
    </swiper-slide>
  </swiper>
</template>
<script>
import { reportData } from '@/api/report';
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
export default {
  components: {
    Swiper,
    SwiperSlide,
  },
  props: {
    hmGameList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      swiperOption: {
        slidesPerView: 5,
        spaceBetween: 10,
        width: 380,
        grabCursor: true,
      },
    };
  },
  methods: {
    handleLinkTo(url) {
      reportData({
        type: 2, // 进入游戏中心
        data_type: 2,
      });
      window.open(url, '_self');
    },
  },
};
</script>

<style lang='scss' module>
.box {
  width: 340px;
  min-height: 57px;
  padding-top: 10px;
  overflow-x: auto;
  display: flex;
  .game-list {
    width: 85px;
    display: inline-block;
    margin-bottom: 17px;
    img {
      width: 57px;
      display: block;
      margin-left: auto;
      margin-right: auto;
      margin-bottom: 7px;
      border-radius: 12px;
    }
    div {
      width: 100%;
      height: 13px;
      text-align: center;
      font-size: 10px;
      line-height: 13px;
    }
  }
}
</style>
